import './setup/icons';
import './setup/registerComponents';
import './setup/globals';
import './setup/pwa';

import('./legacy');
